export const GET_POPULAR_MOVIES  = "GET_POPULAR_MOVIES";
export const RECIEVED_POPULAR_MOVIES  = "RECIEVED_POPULAR_MOVIES";
export const FAILED_POPULAR_MOVIES  = "RECIEVED_POPULAR_MOVIES";
export const GET_MOVIE  = "GET_MOVIE ";
export const RECIEVED_GET_MOVIE   = "RECIEVED_GET_MOVIE ";
export const FAILED_GET_MOVIE   = "FAILED_GET_MOVIE";
export const GET_CAST = "GET_CAST"
export const RECIEVED_GET_CAST = "RECIEVED_GET_CAST"
export const FAILED_GET_CAST = "FAILED_GET_CAST"
export const GET_VIDEO = "GET_VIDEO"
export const RECIEVED_GET_VIDEO = "RECIEVED_GET_VIDEO"
export const FAILED_GET_VIDEO = "FAILED_GET_VIDEO"
export const GET_SERIES = "GET_SERIES"
export const RECIEVED_GET_SERIES = "RECIEVED_GET_SERIES"
export const FAILED_GET_SERIES = "FAILED_GET_SERIES"
export const GET_SERIES_CAST = "GET_SERIES_CAST"
export const RECIEVED_GET_SERIES_CAST = "RECIEVED_GET_SERIES_CAST"
export const FAILED_GET_SERIES_CAST = "FAILED_GET_SERIES_CAST"
export const GET_SERIES_VIDEO = "GET_SERIES_VIDEO"
export const RECIEVED_GET_SERIES_VIDEO = "RECIEVED_GET_SERIES_VIDEO"
export const FAILED_GET_SERIES_VIDEO = "FAILED_GET_SERIES_VIDEO"